import { ReportResultBaseModel } from '@treasury/domain/reports/report-results.entity';
import { TmBaseComponent } from '@treasury/presentation';
import { TmSummaryTile } from '@treasury/presentation/components/tm-summary-tile';
import { formatUsdCurrency } from '@treasury/utils';
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

export const tagName = 'transaction-report-summary';
@customElement(tagName)
export class TransactionReportSummary extends TmBaseComponent {
    @property()
    public report!: ReportResultBaseModel;

    @state()
    private selectedTile?: TmSummaryTile;

    private get filterOn() {
        if (this.selectedTile && this.selectedTile.id) {
            return {
                key: 'accountType',
                value: this.selectedTile.id,
            };
        }
        return undefined;
    }

    public render() {
        if (!this.report) {
            return nothing;
        }
        if (this.report.dateType === 'Date Range') {
            return nothing;
        }
        return html`<div class="flex w-full justify-around">
            <tm-summary-tile
                .summaryTile=${{
                    id: 'Checking',
                    title: 'Checking',
                    totalAmount: html`<div class="flex flex-col">
                        <div class="flex flex-row justify-end items-baseline" id="cr">
                            <div class="text-xs">(${this.report.checkingTotals.creditCount})</div>
                            <div class="text-sm font-bold px-1">
                                ${formatUsdCurrency(this.report.checkingTotals.creditTotal)}
                            </div>
                            <div class="text-xs">CR</div>
                        </div>
                        <div class="flex flex-row justify-end items-baseline pt-1" id="dr">
                            <div class="text-xs">(${this.report.checkingTotals.debitCount})</div>
                            <div class="text-sm font-bold px-1">
                                ${formatUsdCurrency(this.report.checkingTotals.debitTotal)}
                            </div>
                            <div class="text-xs">DR</div>
                        </div>
                    </div>`,
                    count: this.report.checkingTotalCount,
                }}
                .showCount=${false}
                .isSelected=${this.selectedTile?.title === 'Checking'}
                @tileClicked=${this.handleTileSelection}
            ></tm-summary-tile>
            <tm-summary-tile
                .summaryTile=${{
                    id: 'Savings',
                    title: 'Savings',
                    totalAmount: html`<div class="flex flex-col">
                        <div class="flex flex-row justify-end items-baseline" id="cr">
                            <div class="text-xs">(${this.report.savingsTotals.creditCount})</div>
                            <div class="text-sm font-bold px-1">
                                ${formatUsdCurrency(this.report.savingsTotals.creditTotal)}
                            </div>
                            <div class="text-xs">CR</div>
                        </div>
                        <div class="flex flex-row justify-end items-baseline pt-1" id="dr">
                            <div class="text-xs">(${this.report.savingsTotals.debitCount})</div>
                            <div class="text-sm font-bold px-1">
                                ${formatUsdCurrency(this.report.savingsTotals.debitTotal)}
                            </div>
                            <div class="text-xs">DR</div>
                        </div>
                    </div>`,
                    count: this.report.savingTotalCount,
                }}
                .showCount=${false}
                .isSelected=${this.selectedTile?.title === 'Savings'}
                @tileClicked=${this.handleTileSelection}
            ></tm-summary-tile>
            <tm-summary-tile
                .summaryTile=${{
                    title: 'Total',
                    totalAmount: html`<div class="flex flex-col">
                        <div class="flex flex-row justify-end items-baseline" id="cr">
                            <div class="text-xs">
                                (${this.report.totalTransactions.creditCount})
                            </div>
                            <div class="text-sm font-bold px-1">
                                ${formatUsdCurrency(this.report.totalTransactions.creditTotal)}
                            </div>
                            <div class="text-xs">CR</div>
                        </div>
                        <div class="flex flex-row justify-end items-baseline pt-1" id="dr">
                            <div class="text-xs">(${this.report.totalTransactions.debitCount})</div>
                            <div class="text-sm font-bold px-1">
                                ${formatUsdCurrency(this.report.totalTransactions.debitTotal)}
                            </div>
                            <div class="text-xs">DR</div>
                        </div>
                    </div>`,
                    count: this.report.totalTransactionCount,
                }}
                .showCount=${false}
                .isSelected=${this.selectedTile?.title === 'Total'}
                @tileClicked=${this.handleTileSelection}
            ></tm-summary-tile>
        </div>`;
    }

    private handleTileSelection(e: CustomEvent) {
        if (!e.detail) {
            return;
        }
        if (this.selectedTile?.title === e.detail.title) {
            this.selectedTile = undefined;
        } else {
            this.selectedTile = e.detail;
        }
        this.dispatchEvent(
            new CustomEvent('filter-tile-changed', {
                detail: this.filterOn,
                bubbles: true,
                composed: true,
            })
        );
    }
}
